import { render, staticRenderFns } from "./InboundDialog.vue?vue&type=template&id=9a65ba72&scoped=true"
import script from "./InboundDialog.vue?vue&type=script&lang=js"
export * from "./InboundDialog.vue?vue&type=script&lang=js"
import style0 from "./InboundDialog.vue?vue&type=style&index=0&id=9a65ba72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a65ba72",
  null
  
)

export default component.exports